import { API_BASE_URL, getBlobRequest, getRequest, patchRequest, postRequest } from "../../api";

const getToken = () => sessionStorage.getItem("token");
const getUid = () => sessionStorage.getItem("uid");

export const fetchLearnerModulesApi = () =>
    getRequest({
        url: `${API_BASE_URL}/api/apprenant/modules`,
        token: getToken(),
        uid: getUid(),
    });

export const fetchLearnerModulePlayerApi = (moduleId) =>
    getRequest({
        url: `${API_BASE_URL}/api/apprenant/modules/${moduleId}/player`,
        token: getToken(),
        uid: getUid(),
    });

export const startLearnerModuleApi = (moduleId, payload = {}) =>
    postRequest({
        url: `${API_BASE_URL}/api/apprenant/modules/${moduleId}/start`,
        data: payload,
        token: getToken(),
        uid: getUid(),
    });

export const startLearnerContentApi = (moduleId, contentId, payload = {}) =>
    postRequest({
        url: `${API_BASE_URL}/api/apprenant/modules/${moduleId}/contents/${contentId}/start`,
        data: payload,
        token: getToken(),
        uid: getUid(),
    });

export const completeLearnerContentApi = (moduleId, contentId, payload = {}) =>
    postRequest({
        url: `${API_BASE_URL}/api/apprenant/modules/${moduleId}/contents/${contentId}/complete`,
        data: payload,
        token: getToken(),
        uid: getUid(),
    });

export const updateLearnerContentProgressApi = (moduleId, contentId, payload = {}) =>
    patchRequest({
        url: `${API_BASE_URL}/api/apprenant/modules/${moduleId}/contents/${contentId}/progress`,
        data: payload,
        token: getToken(),
        uid: getUid(),
    });

export const fetchLearnerContentFileBlobApi = (moduleId, contentId) =>
    getBlobRequest({
        url: `${API_BASE_URL}/api/apprenant/modules/${moduleId}/contents/${contentId}/file`,
        token: getToken(),
        extraHeaders: {
            uid: getUid(),
            "X-Tenant-Id": sessionStorage.getItem("selectedCompanyId"),
        },
    });
